"use client"
import { ComponentConfig } from "@measured/puck"
import { Button } from "antd"
import { motion } from "framer-motion"
import { configs, DefaultImage } from "../../../../external-components"
import "./styles.module.css"

export type SeeMoreSectionProps = {
  imageSrc?: string
  imageMobile?: string
  heading1?: string
  heading2?: string
  buttonValue?: string
}

export const RenderConfig: ComponentConfig<SeeMoreSectionProps> = {
  render: ({ imageSrc, heading1, heading2, buttonValue, imageMobile }: SeeMoreSectionProps) => (
    <div className="justify-center flex">
      <div className="w-[1140px] relative ">
        <motion.div
          style={{ position: "relative" }}
          initial={{ opacity: 0.5, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <div className="absolute left-0 bottom-0 right-0 w-full h-full bg-black opacity-50 rounded-[50px]"></div>
          <img
            className="rounded-[50px] max-sm:hidden"
            src={imageSrc ? `${configs.API_URL}${imageSrc}` : DefaultImage}
            alt="Banner Image"
          />
          <img
            className="rounded-[50px] md:hidden"
            src={imageMobile ? `${configs.API_URL}${imageMobile}` : DefaultImage}
            alt="Banner Image"
          />
        </motion.div>
        <div className="absolute left-[5%] bottom-[6%] justify-start flex flex-col items-start">
          <h1 className="italic text-[28px] pb-[5px] text-white text-left font-bold">{heading1}</h1>
          <h2 className="text-[28px] text-white text-left font-bold">{heading2}</h2>
          <Button
            style={{ background: "linear-gradient(62.29deg, #5bb97a 13.03%, #298cca 89.38%)" }}
            className="my-7 py-[11px] px-[32px] border-0 rounded-[80px] text-white h-[40px] hover:text-[#0056b3] transition-none"
          >
            {buttonValue}
          </Button>
        </div>
      </div>
    </div>
  ),
}
